import { render, staticRenderFns } from "./EstatisticaLotes.vue?vue&type=template&id=56f50914"
import script from "./EstatisticaLotes.vue?vue&type=script&lang=js"
export * from "./EstatisticaLotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports